import { createAttachmentApi } from "../../../components/lifecycle/createAttachmentApi";

export const brokerAttachmentApi = createAttachmentApi({
  listKey: (entityId, lifecycleName) =>
    ["brokerAttachments", entityId, lifecycleName] as const,
  list: (client, { entityId, lifecycleName }) =>
    client.brokerListAttachments.brokerListAttachments({
      brokerId: entityId,
      lifecycleName
    }),
  download: (client, { entityId, lifecycleName, fileName }) =>
    client.brokerDownloadAttachment.brokerDownloadAttachment(
      { brokerId: entityId, lifecycleName, fileName },
      { format: "blob" }
    ),
  delete: (client, { entityId, lifecycleName, fileName }) =>
    client.brokerDeleteAttachment.brokerDeleteAttachment({
      brokerId: entityId,
      lifecycleName,
      fileName
    }),
  upload: { path: "/BrokerUploadAttachment", idParameter: "brokerId" }
});
